export default {
      id: "hand-usage",
      viewBox: "0 0 54 52",
      url: __webpack_public_path__ + "../../sprite.svg#hand-usage",
      toString: function () {
        return this.url;
      }
    }